import Constants from '../actions/types';

const initialState = {
  transformFunctions: [],
  error: null
};

const transformFunctionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.TRANSFORMFUNCTIONS_GET_SUCCESS: {
      const newState = {
        transformFunctions: action.payload,
        error: null
      };

      return newState;
    }

    case Constants.TRANSFORMFUNCTIONS_GET_FAILURE: {
      const newState = {
        transformFunctions: [],
        error: action.payload
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default transformFunctionsReducer;
